export enum ReturnType {
  ANY,
  STRING,
  INT,
  DOUBLE,
  BOOLEAN
}
